import { FormInput } from "@farzoom/common-ui-components";
import { Checkbox, Col, Row } from "antd";
import type { CheckboxChangeEvent } from "antd/es/checkbox";
import { disabledDate, useStyles } from "../personInfoModal";
import { ProxyBlock } from "./proxyBlock";
import { VerticalSpace } from "@app/UI/VerticalSpace";
import { FormInputDateTime } from "@app/common-ui-components/FormInputDateTime";

export const CEOBlock = ({ control, setValue, readonly, register, personW }) => {
  const classes = useStyles();

  const onHeadChange = (e: CheckboxChangeEvent) => {
    setValue("personRole.isHead", e.target.checked);
    if (e.target.checked) {
      setValue("personRole.isSigner", true);
      setValue("personRole.employee.byProxy", false);
      setValue("personRole.employee.proxy.proxyName", null);
      setValue("personRole.employee.proxy.proxyDateStart", null);
      setValue("personRole.employee.proxy.proxyDateEnd", null);
    }
  };

  const onSignerChange = (e: CheckboxChangeEvent) => {
    setValue("personRole.isSigner", e.target.checked);

    if (!e.target.checked) {
      setValue("personRole.employee.byProxy", false);
      setValue("personRole.employee.proxy.proxyName", null);
      setValue("personRole.employee.proxy.proxyDateStart", null);
      setValue("personRole.employee.proxy.proxyDateEnd", null);
    }
  };

  return (
    <Row gutter={[16, 16]} className={classes.block}>
      <Col span={24} xl={6}>
        <VerticalSpace size="small">
          <Checkbox
            {...register("personRole.isHead")}
            checked={personW?.personRole?.isHead}
            onChange={onHeadChange}
          >
            Руководитель
          </Checkbox>
          <Checkbox
            {...register("personRole.isSigner")}
            checked={personW?.personRole?.isSigner}
            onChange={onSignerChange}
          >
            Подписант
          </Checkbox>
        </VerticalSpace>
      </Col>
      <Col span={24} xl={18}>
        <VerticalSpace>
          <Row gutter={8} align="top">
            <Col span={10}>
              <FormInput
                name="personRole.employee.position"
                control={control}
                setValue={setValue}
                label="Должность"
                disabled={readonly}
              />
            </Col>
            <Col span={7}>
              <FormInputDateTime
                name="personRole.employee.positionDateStart"
                control={control}
                setValue={setValue}
                label="Дата назначения"
                controls={false}
                disabledDate={disabledDate}
                disabled={readonly}
              />
            </Col>
            <Col span={7}>
              <FormInputDateTime
                name="personRole.employee.positionDateEnd"
                control={control}
                setValue={setValue}
                label="Дата истечения полномочий"
                controls={false}
                disabled={readonly}
                allowClear
              />
            </Col>
          </Row>
          <Row gutter={8} align="top">
            <Col span={10}>
              <FormInput
                name="personRole.employee.authorizingDoc.authorizingDocName"
                control={control}
                setValue={setValue}
                label="Документ о назначении на должность"
                disabled={readonly}
              />
            </Col>
            <Col span={7}>
              <FormInput
                name="personRole.employee.authorizingDoc.authorizingDocNumber"
                control={control}
                setValue={setValue}
                label="Номер документа"
                disabled={readonly}
              />
            </Col>
            <Col span={7}>
              <FormInputDateTime
                name="personRole.employee.authorizingDoc.authorizingDocDate"
                control={control}
                setValue={setValue}
                label="Дата"
                controls={false}
                disabledDate={disabledDate}
                disabled={readonly}
              />
            </Col>
          </Row>

          {personW?.personRole?.isSigner && (
            <ProxyBlock
              register={register}
              control={control}
              setValue={setValue}
              readonly={readonly}
              personW={personW}
            />
          )}
        </VerticalSpace>
      </Col>
    </Row>
  );
};
